import React from "react";

import MuiDialog from "@mui/material/Dialog";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

import styles from "./BatchPreference.module.scss";

const ProceedToPaymentModal = ({ open, onCancel, onConfirm }) => {
  return (
    <MuiDialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      aria-labelledby="proceed-to-payment-title"
      PaperProps={{
        sx: {
          width: "480px",
          maxWidth: "95vw",
          borderRadius: "14px",
          overflow: "hidden",
        },
      }}
    >
      <div className={styles.confirmModal}>
        <div className={styles.confirmModalHeader}>
          <div className={styles.confirmModalTitleWrap}>
            <EventAvailableIcon className={styles.confirmModalTitleIcon} />
            <h2 id="proceed-to-payment-title" className={styles.confirmModalTitle}>
              Confirm
            </h2>
          </div>
        </div>

        <div className={styles.confirmModalBody}>
          <p className={styles.proceedModalMessage}>
            Review the schedule and start date carefully before confirming.
          </p>
        </div>

        <div className={styles.confirmModalActions}>
          <button
            type="button"
            className={styles.confirmCancelButton}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles.confirmSubmitButton}
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </MuiDialog>
  );
};

export default ProceedToPaymentModal;
